// client/src/components/bracket/BracketLayer.js
import React, { forwardRef } from 'react'
import './BracketLayer.css'

/**
 * BracketLayer - Absolute positioning surface for bracket elements
 *
 * This component provides:
 * - Absolute positioning surface for all bracket elements
 * - Coordinate system for child components
 * - Layout management for complex bracket structures
 * - Support for dynamic sizing based on content
 */
const BracketLayer = forwardRef(function BracketLayer(
  {
    children,
    className = '',
    width = 'auto',
    height = 'auto',
    minWidth = 800,
    minHeight = 400,
    style = {},
    ...otherProps
  },
  ref
) {
  const layerClasses = ['bracket-layer', className].filter(Boolean).join(' ')

  const layerStyle = {
    width,
    height,
    minWidth,
    minHeight,
    ...style,
  }

  return (
    <div ref={ref} className={layerClasses} style={layerStyle} {...otherProps}>
      {children}
    </div>
  )
})

BracketLayer.displayName = 'BracketLayer'

export default BracketLayer
